var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efb43c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.65,14.15,12.23,1.29a2.57,2.57,0,0,0-4.46,0L.35,14.15A2.57,2.57,0,0,0,2.58,18H17.42A2.57,2.57,0,0,0,19.65,14.15Zm-8.86.26a1,1,0,0,1-.79.34,1,1,0,0,1-.8-.32,1.08,1.08,0,0,1-.28-.74,1.13,1.13,0,0,1,.28-.76,1,1,0,0,1,.78-.32,1,1,0,0,1,.8.32,1.1,1.1,0,0,1,0,1.48Zm.14-4.95c-.08.23-.15.47-.21.7s-.14.48-.22.72c-.17.51-.32.76-.46.74s-.32-.28-.51-.78l-.16-.47c-.07-.23-.17-.53-.3-.91A8.68,8.68,0,0,1,8.6,6.91c0-1.19.47-1.79,1.4-1.82s1.4.57,1.4,1.75A9.26,9.26,0,0,1,10.93,9.46Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.4215dc29523420250306f12650a6c3b7.svg";
export { ForwardRef as ReactComponent };